const cardItems = [
  {
    title: '某知名艺人被拍到深夜出入高档会所',
    desc: '独家照片曝光，引发网友热议，当事人尚未回应。网友纷纷猜测背后真相。',
    tag: '娱乐圈',
    time: '2小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20night%20outing%20abstract%20visual%20with%20mysterious%20warm%20evening%20lighting%2C%20luxury%20lifestyle%20aesthetic%2C%20paparazzi%20style%20photography%2C%20coral%20and%20deep%20amber%20tones&width=640&height=400&seq=card-1&orientation=landscape',
  },
  {
    title: '热门网剧剧组内部矛盾激化，导演与主演发生争执',
    desc: '知情人士透露拍摄现场气氛紧张，可能影响后续播出计划。',
    tag: '影视圈',
    time: '4小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20drama%20abstract%20visual%20with%20tense%20warm%20atmosphere%2C%20cinematic%20lighting%2C%20production%20crew%20silhouettes%2C%20dramatic%20coral%20color%20palette&width=640&height=400&seq=card-2&orientation=landscape',
  },
  {
    title: '知名品牌代言人翻车事件持续发酵',
    desc: '品牌方连夜发布致歉声明，多个合作方宣布暂停合作。',
    tag: '商业瓜',
    time: '6小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Brand%20crisis%20abstract%20visual%20with%20dramatic%20warm%20corporate%20atmosphere%2C%20breaking%20news%20aesthetic%2C%20modern%20business%20setting%2C%20coral%20and%20amber%20tones&width=640&height=400&seq=card-3&orientation=landscape',
  },
  {
    title: '某选秀节目选手被曝学历造假',
    desc: '网友扒出多份证据，节目组表示正在核实相关情况。',
    tag: '综艺圈',
    time: '8小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20scandal%20abstract%20visual%20with%20dramatic%20stage%20lighting%2C%20reality%20TV%20aesthetic%2C%20confrontational%20warm%20atmosphere&width=640&height=400&seq=card-4&orientation=landscape',
  },
  {
    title: '社交平台知名大V被官方点名批评',
    desc: '因发布不实信息被多平台联合封禁，粉丝数量一夜腰斩。',
    tag: '互联网',
    time: '10小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20account%20suspension%20abstract%20visual%20with%20digital%20glitch%20effects%2C%20warm%20dramatic%20lighting%2C%20modern%20internet%20culture%20aesthetic&width=640&height=400&seq=card-5&orientation=landscape',
  },
  {
    title: '某歌手新专辑销量造假疑云',
    desc: '业内人士爆料数据异常，粉丝与质疑者在社交平台展开激烈辩论。',
    tag: '音乐圈',
    time: '12小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20album%20controversy%20abstract%20visual%20with%20warm%20concert%20lighting%2C%20record%20industry%20aesthetic%2C%20dramatic%20atmosphere%20with%20coral%20accents&width=640&height=400&seq=card-6&orientation=landscape',
  },
];

const updateItems = [
  { time: '2026-07-30 14:30', title: '某女星工作室发布律师函，否认离婚传闻', tag: '最新' },
  { time: '2026-07-30 12:15', title: '热播综艺录制因天气原因延期，新档期待定', tag: '快讯' },
  { time: '2026-07-30 10:00', title: '知名导演新片发布首支预告，网友评论两极分化', tag: '热点' },
  { time: '2026-07-30 08:45', title: '某顶流男星被拍到与神秘女子同游日本', tag: '最新' },
  { time: '2026-07-29 22:30', title: '网红直播带货翻车，品牌方连夜发布退款公告', tag: '快讯' },
  { time: '2026-07-29 18:00', title: '某综艺选手退赛声明引争议，节目组紧急回应', tag: '热点' },
  { time: '2026-07-29 14:20', title: '知名品牌官宣新代言人，前任代言人粉丝不满', tag: '快讯' },
];

const featureItems = [
  {
    icon: 'ri-shield-check-line',
    title: '高清画质',
    desc: '所有视频支持1080P高清播放，自动适配网络带宽，带来流畅观影体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '每日从全网50余个优质内容源采集200余条最新视频，确保第一时间推送。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '页面全面兼容PC端与移动端，手机浏览器直接访问，无需下载任何APP。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '免费观看',
    desc: '全站内容免费开放，无需注册登录，即点即看，零门槛享受吃瓜乐趣。',
  },
  {
    icon: 'ri-global-line',
    title: '全网聚合',
    desc: '覆盖娱乐圈、网红圈、社会热点等多个领域，一个平台看尽全网热门视频。',
  },
];

export function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">精选推荐</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">编辑精选的优质吃瓜内容</p>
        <div className="mt-6 md:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <a
              key={item.imageUrl}
              href="#media"
              className="group block bg-background-100 border border-background-200/60 rounded-lg overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                  }}
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-white text-[10px] md:text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-2 left-2 px-1.5 py-0.5 rounded bg-black/60 text-white text-[10px]">
                  {item.time}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">最新爆料</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">实时追踪 · 第一时间掌握吃瓜动态</p>
        <div className="mt-6 md:mt-8 max-w-3xl mx-auto">
          <div className="relative pl-6 md:pl-8 border-l-2 border-primary-200">
            {updateItems.map((item, i) => (
              <a
                key={i}
                href="#media"
                className={`relative block pb-6 md:pb-7 last:pb-0 cursor-pointer group ${
                  i < updateItems.length - 1 ? '' : ''
                }`}
              >
                <span className="absolute -left-[25px] md:-left-[29px] top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 border-2 border-primary-200"></span>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                  <span className="text-xs md:text-sm text-foreground-400 whitespace-nowrap">{item.time}</span>
                  {item.tag && (
                    <span className={`self-start px-1.5 py-0.5 rounded text-[10px] md:text-xs font-medium whitespace-nowrap ${
                      item.tag === '最新' ? 'bg-primary-100 text-primary-600' :
                      item.tag === '热点' ? 'bg-accent-100 text-accent-600' :
                      'bg-secondary-100 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="mt-1 text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">平台优势</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">为什么选择51吃瓜视频</p>
        <div className="mt-6 md:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 border border-background-200/60 rounded-lg p-4 md:p-5 text-center transition-all hover:border-primary-200"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center mx-auto">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </span>
              <h3 className="mt-3 md:mt-4 text-sm md:text-base font-bold text-foreground-900">{item.title}</h3>
              <p className="mt-1.5 md:mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}